/**
 * PasswordRules — small live-checked rule list rendered under any
 * "set new password" input. Mirrors backend/password_policy.py so the
 * UI never disagrees with the server:
 *
 *   • min 8 characters
 *   • at least one uppercase letter
 *   • at least one lowercase letter
 *   • at least one digit
 *   • at least one symbol
 *
 * Pure presentational — takes the raw password string and renders a
 * compact bulleted list with green/grey ticks. No backend calls.
 */
import { CheckCircle2, Circle } from "lucide-react";

const RULES = [
  { key: "length", label: "At least 8 characters",  test: (p) => p.length >= 8 },
  { key: "upper",  label: "One uppercase letter",   test: (p) => /[A-Z]/.test(p) },
  { key: "lower",  label: "One lowercase letter",   test: (p) => /[a-z]/.test(p) },
  { key: "digit",  label: "One digit",              test: (p) => /\d/.test(p) },
  { key: "symbol", label: "One symbol (! @ # $ …)", test: (p) => /[!-/:-@[-`{-~]/.test(p) },
];

export default function PasswordRules({ password = "", testIdPrefix = "password-rules" }) {
  return (
    <ul
      data-testid={`${testIdPrefix}-rules`}
      className="mt-2 space-y-0.5 text-[11px] text-slate-500"
    >
      {RULES.map((r) => {
        const ok = r.test(password);
        return (
          <li
            key={r.key}
            data-testid={`${testIdPrefix}-rule-${r.key}${ok ? "-ok" : ""}`}
            className={`flex items-center gap-1.5 ${ok ? "text-emerald-700" : "text-slate-500"}`}
          >
            {ok
              ? <CheckCircle2 className="w-3 h-3" />
              : <Circle className="w-3 h-3" />}
            {r.label}
          </li>
        );
      })}
    </ul>
  );
}
